import { createTrackingEmitterHooks } from "@b2bportal/core-tracking";

export type FlightsPriceFreezeTrackingAttributes = {
  is_quoted_price: boolean;
  pax_total: number;
  price_freeze_cap_local_currency: number;
  price_freeze_cap_usd: number;
  price_freeze_duration: number;
  price_freeze_fee_local_currency: number;
  price_freeze_fee_usd: number;
  price_freeze_price_per_unit_local_currency: number;
  price_freeze_price_per_unit_usd: number;
  price_freeze_total_price_local_currency: number;
  price_freeze_total_price_usd: number;
  product_type: "air-price-freeze";
};

export const FlightsPriceFreezePurchaseRawEventName = {
  FlightsPriceFreezeEntryLoaded: "FlightsPriceFreezeEntryLoaded",
  FlightsPriceFreezeEntryClicked: "FlightsPriceFreezeEntryClicked",
  FlightsPriceFreezeDetailsLoaded: "FlightsPriceFreezeDetailsLoaded",
  FlightsPriceFreezeDurationChanged: "FlightsPriceFreezeDurationChanged",
  FlightsPriceFreezePaymentLoaded: "FlightsPriceFreezePaymentLoaded",
  FlightsPriceFreezePurchaseClicked: "FlightsPriceFreezePurchaseClicked",
  FlightsPriceFreezePurchaseConfirmation:
    "FlightsPriceFreezePurchaseConfirmation",
} as const;

export const FlightsPriceFreezeExerciseRawEventName = {
  FlightsPriceFreezeExerciseEntryClicked:
    "FlightsPriceFreezeExerciseEntryClicked",
  FlightsPriceFreezeExerciseMissionControlLoaded:
    "FlightsPriceFreezeExerciseMissionControlLoaded",
  FlightsPriceFreezeExerciseContinueClicked:
    "FlightsPriceFreezeExerciseContinueClicked",
  FlightsPriceFreezeExerciseNoAvailability:
    "FlightsPriceFreezeExerciseNoAvailability",
  FlightsPriceFreezeExerciseRequestRefund:
    "FlightsPriceFreezeExerciseRequestRefund",
} as const;

export const FlightsPriceFreezeRawEventName = {
  ...FlightsPriceFreezePurchaseRawEventName,
  ...FlightsPriceFreezeExerciseRawEventName,
} as const;

export type FlightsPriceFreezePurchaseRawEventName =
  (typeof FlightsPriceFreezePurchaseRawEventName)[keyof typeof FlightsPriceFreezePurchaseRawEventName];

export type FlightsPriceFreezeExerciseRawEventName =
  (typeof FlightsPriceFreezeExerciseRawEventName)[keyof typeof FlightsPriceFreezeExerciseRawEventName];

export type FlightsPriceFreezeRawEventName =
  (typeof FlightsPriceFreezeRawEventName)[keyof typeof FlightsPriceFreezeRawEventName];

export type FlightsPriceFreezeRawEvent = {
  [K in FlightsPriceFreezeRawEventName]: {
    name: K;
    properties?: Record<string, unknown>;
  };
}[FlightsPriceFreezeRawEventName];

export const {
  useEmitRawEvent: useEmitCoreFlightsPriceFreezeRawEvent,
  useEmitRawEventOnce: useEmitCoreFlightsPriceFreezeRawEventOnce,
} = createTrackingEmitterHooks<FlightsPriceFreezeRawEvent>();
